
export interface RequestTypeQualification {
	id: number;
	serviceRequestTypeId: number;
	masterQualificationId: number;
	useForAutomatch: number;
	required: number;
}

export class RequestTypeQualification {
	constructor() {
		this.id = 0;
		this.serviceRequestTypeId = 0;
		this.useForAutomatch = 0;
		this.required = 0;
	}


}
